import { User } from '@app/core/interfaces';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserAuth from './userAuth.reducer';
import { State } from './userAuth.reducer';

export const selectUserAuthState = createFeatureSelector<fromUserAuth.State>(
  fromUserAuth.userAuthFeatureKey
);

export const selectIsImpersonating = createSelector(
  selectUserAuthState,
  (userAuthState: State): boolean => userAuthState.isImpersonating
);

export const selectIsAuthenticated = createSelector(
  selectUserAuthState,
  (userAuthState: State): boolean => userAuthState.isAuthenticated
);

export const selectUser = createSelector(
  selectUserAuthState,
  (userAuthState: State): User | null => userAuthState.user
);

export const selectUserRole = createSelector(
  selectUser,
  (user: User | null): string => user?.role ? user?.role : ''
);
